import { render, staticRenderFns } from "./ModalPecas.vue?vue&type=template&id=1e74b437&scoped=true&"
import script from "./ModalPecas.vue?vue&type=script&lang=js&"
export * from "./ModalPecas.vue?vue&type=script&lang=js&"
import style0 from "./ModalPecas.vue?vue&type=style&index=0&id=1e74b437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e74b437",
  null
  
)

export default component.exports